import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
import { passwordValidation } from "@app/utils/validation";

export const AccountSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Email,
    id: "userId",
    label: "이메일",
    placeholder: "이메일을 입력하세요.",
    behavior: {
      required: true,
    },
  },
  {
    type: FormFieldType.Password,
    id: "password",
    label: "비밀번호",
    placeholder: "비밀번호를 입력하세요.",
    description:
      "비밀번호는 숫자 + 영문(소/대문자) + 특수문자로 8 ~ 20 자리 수입니다.",
    validationFunction: (value) => passwordValidation.test(value),
    behavior: {
      required: true,
    },
  },
  {
    type: FormFieldType.Password,
    id: "confirmPassword",
    label: "비밀번호 확인",
    placeholder: "비밀번호를 한번 더 입력하세요.",
    behavior: {
      required: true,
    },
  },
];
